import { variants } from "@/components/ui/Badge/utils";

import { BatteryState } from "@/features/system/types";

export const DEVICE_BATTERY_BADGE_VARIANTS: Record<
  keyof typeof BatteryState,
  keyof typeof variants
> = {
  BATTERY_STATE_UNSPECIFIED: "gray",
  EMPTY: "red",
  LOW: "yellow",
  OK: "green",
};

export const MAP_PADDING = 0.2;
export const READER_MAP_DEAFAULT_ZOOM = 8;
